<div class="form-group">
    <label class="input-label">Minimum activities required</label>
    <input class="form-control"
           name="minActivities"
           type="number"
           value="{{fieldOptions.validate.minActivities}}"
           [(ngModel)]="fieldOptions.validate.minActivities">
</div>